import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IPageDataV4 } from '@df/catalog/cms/cms-model.interface';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content/component/icms-component.decorator';
import { ICmsContent } from '@icms/core/content/component/icms-content.decorator';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { ActionComponent } from '../../../../ui/api/action.component';
import { NBlogPostPageType } from '../../page/post-view/cms-blog-page-post-view.component';
import { CmsBlogComponentMoreStoriesItemComponent } from './item/cms-blog-component-more-stories-item.component';

export interface IPageComponentBlogMoreStoriesData extends NICmsContentComponent.IData {
    title?: string;
    title_font_style?: string;
    items?: IPageComponentSelectPage[];
}
interface IPageComponentSelectPage {
    page: number;
}
@ICmsComponent<CmsBlogComponentMoreStoriesComponent>({
    id: 'blog-more-stories',
    name: 'Blog / More Stories',
    tags: ['Blog'],
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            default: 'More stories'
        },
        <NICmsContentField.IChoiceField>{
            key: 'title_font_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title Font Style',
            options: TextStyleOptions,
            default: 'h1'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Blog pages',
            itemName: 'item',
            defaultSize: 4,
            fields: [
                <NICmsContentField.IRelationField<IPageDataV4, ICmsPage>>{
                    key: 'page',
                    type: NICmsContentField.EFieldType.relation,
                    title: 'Select Page',
                    required: true,
                    options: {
                        type: 'page',
                        filter: (model: ICmsPage, data: IPageDataV4) => model?.rawData?.pageType === NBlogPostPageType.typeId
                    }
                }
            ]
        },
        NICmsContentComponent.backgroundField
    ]
})
@Component({
    selector: 'cms-blog-component-more-stories',
    templateUrl: 'cms-blog-component-more-stories.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [TranslationModule, CommonModule, ActionComponent, CmsBlogComponentMoreStoriesItemComponent, GridModule, ICmsClientModule]
})
export class CmsBlogComponentMoreStoriesComponent extends UiComponent implements OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentBlogMoreStoriesData;

    protected pages: IPageComponentSelectPage[] = [];
    protected end = 0;
    protected isBtnVisible = false;

    override ngOnInit() {
        this.loadMore();
        super.ngOnInit();
    }

    getPages(): IPageComponentSelectPage[] {
        if (this.client.isS || this.client.isM) {
            this.end += 2;
        } else {
            this.end += 4;
        }
        if (!this.component.items) {
            return [];
        }
        if (this.end > this.component.items!.length) {
            return this.component.items;
        } else {
            return this.component.items.slice(0, this.end);
        }
    }

    checkBtnStatus(): boolean {
        return this.pages?.length < (this.component.items?.length || 0);
    }

    loadMore() {
        this.pages = this.getPages();
        this.isBtnVisible = this.checkBtnStatus();
        this.detectChanges();
    }
}
